import styled from 'styled-components'

export const LeadershipModalHolder = styled.div<{
  contentType: string
}>`
  display: flex;
  flex-direction: row;
  align-items: ${props => (props.contentType === 'speakerText' ? 'start' : 'center')};

  ${props => props.theme.breakpoints.down('xs')} {
    flex-direction: column;
    overflow-x: hidden;
    overflow-y: auto;
  }
`

export const LeadershipModalImage = styled.div`
  width: 250px;
  height: 288px;
  img {
    width: 250px;
    height: 288px;
    object-fit: contain;
  }

  ${props => props.theme.breakpoints.down('xs')} {
    width: auto;
    height: auto;
    aspect-ratio: 278 / 320;
    img {
      width: 100%;
      height: 100%;
      object-fit: cover;
    }
  }
`

export const LeadershipModalContent = styled.div`
  display: flex;
  width: 414px;
  flex-direction: column;
  margin-left: 32px;

  ${props => props.theme.breakpoints.down('xs')} {
    width: 100%;
    margin: auto;
  }
`

export const RowContent = styled.div`
  &.Content-FullName {
    margin-top: 16px;
  }
  &.Content-Role {
    margin-top: 2px;
  }
  &.Content-MiniBio {
    margin-top: 16px;
  }

  ${props => props.theme.breakpoints.down('xs')} {
    &.Content-FullName {
      margin-top: 32px;
    }
    &.Content-MiniBio {
      min-height: unset;
    }
  }
`

export const LeadershipModalFooter = styled.div`
  display: flex;
  margin-top: 24px;

  ${props => props.theme.breakpoints.down('xs')} {
    margin-top: 16px;
  }

  .Content-LinkProfile {
    display: flex;
    margin-right: 18px;
    .BioCardFooter-LinkedInProfile,
    .BioCardFooter-TwitterProfile {
      margin-right: 10px;
    }
    &:hover {
      .BioCardFooter-ProfileType {
        color: ${props => props.theme.webMktPalette.text.actionLight};
      }
      .BioCardFooter-TwitterProfile {
        background-image: url('https://images.ctfassets.net/5965pury2lcm/1GjxGoTBTRRFpxevacnau6/4eeda6e6ee80bd43f4fb309d6cf4ef61/Twitter_Icon_Hover.svg');
      }
      .BioCardFooter-LinkedInProfile {
        background-image: url('https://images.ctfassets.net/5965pury2lcm/48rlfbSTKg2uv9RQesJX1w/49c4630153c0416ef365f06be3736263/LinkedIn_Icon_Hover.svg');
      }
    }
  }
`

export const LinkItem = styled.div`
  width: 24px;
  height: 24px;
  background-repeat: no-repeat;
  background-size: contain;
  background-position: center;
  &.BioCardFooter-TwitterProfile {
    margin-top: 2px;
    background-image: url('https://images.ctfassets.net/5965pury2lcm/4dAYUTsXPrkP1BNdPSFmSp/c65e9a1d6fedea138b5c79ae4cb9a26f/Twitter24x24.svg');
  }
  &.BioCardFooter-LinkedInProfile {
    background-image: url('https://images.ctfassets.net/5965pury2lcm/229hKtHNHuk5CtK8CJLnh/2ae651f3bb0995f2ced37f008ac619b5/Linkedin16x16.svg');
  }
`
